import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderBy' })

export class OrderByPipe implements PipeTransform {
    transform(obj: any): any {
        return obj;
    }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/pipes/orderBy.pipe.ts